import { pxToRem } from '../unit-converter';

/**
 * Aplica variável de altura para ser usado em conjunto com o CSS quando
 * não há suporte do navegador para aspect-ratio.
 *
 * @category Style
 */
export const applyAspectRatioVariables = (el: HTMLElement) => {
  const percentageHeight = getComputedStyle(el).getPropertyValue('--ids-aspect-ratio');

  if (percentageHeight) {
    el.style.setProperty('aspect-ratio', 'initial');
    el.style.setProperty('--ids-height', `calc(${pxToRem(el.offsetWidth)} / ${percentageHeight})`);
  }
};
